export default __webpack_public_path__ + "static/media/favoriteoutlined.a626f56a.svg";